import { useState } from "react";
import { useTranslation } from "react-i18next";

const TermCard = ({ term }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Container الكارت: ممتد بالكامل وعمودي في كل الشاشات لتبقى الصورة في الأعلى */}
      <div className="flex flex-col w-full bg-white rounded-2xl shadow-mainShadow overflow-hidden border border-gray-100 transition-all duration-300 hover:shadow-lg">
        
        {/* قسم الصورة: في الأعلى دائماً، وبارتفاع متجاوب ومناسب لعرض الشاشة الكامل */}
        <div 
          onClick={togglePopup} 
          className="relative h-[220px] sm:h-[320px] md:h-[400px] w-full overflow-hidden cursor-pointer group"
        >
          <img 
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-102" 
            src={term.img} 
            alt={term.name} 
          />
          {/* طبقة التلميح عند تمرير الماوس */}
          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
            <span className="bg-white/80 backdrop-blur-sm text-gray-800 text-xs px-3 py-1.5 rounded-full font-medium">
              🔍 {t("اضغط للتكبير")}
            </span>
          </div>
        </div>

        {/* قسم النصوص والمعلومات بأسفل الصورة */}
        <div className="p-6 md:p-8 flex flex-col space-y-4">
          <div>
            <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-4">{t(term.name)}</h2>
            
            {/* Cost Section */}
            <section className="mb-4">
              <h3 className="text-sm font-semibold text-mainRed mb-1 md:text-base">{t("cost")}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{t(term.cost)}</p>
            </section>
            
            {/* Risks Section */}
            <section>
              <h3 className="text-sm font-semibold text-mainRed mb-1 md:text-base">
                {t("risks")}
                {term.insurance && <span className="text-xs text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md ml-2 inline-block">{t("insurance-")}</span>}
                :
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{t(term.risks)}</p>
            </section>
          </div>
        </div>
      </div>

      {/* Image Popup Modal */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm transition-opacity duration-300"
          onClick={togglePopup}
        >
          <div className="relative max-w-4xl w-full max-h-[90vh] flex flex-col items-center justify-center">
            
            {/* Close Button */}
            <button 
              onClick={togglePopup}
              className="absolute -top-12 right-0 bg-white text-black bg-opacity-90 hover:bg-opacity-100 transition-all rounded-full p-2 w-10 h-10 flex items-center justify-center font-bold text-lg shadow-lg focus:outline-none"
              aria-label="Close modal"
            >
              ✕
            </button>

            {/* Popup Image */}
            <img 
              src={term.img} 
              alt={term.name} 
              className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()} 
            />
            
            {/* Title in Popup */}
            <p className="text-white text-lg font-semibold mt-4 text-center bg-black/40 px-4 py-2 rounded-xl backdrop-blur-md">
              {t(term.name)}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TermCard;